module.exports = __webpack_public_path__ + "static/media/ENTJ.6dc29ea7.png";